export interface SmsPlaceholder {
  code: string;
  label: string;
  category: string;
}

const SmsPlaceholders: SmsPlaceholder[] = [
  { code: '#TitleID#', label: 'Civilité du client (M., Mme...)', category: 'Client' },
  { code: '#CustomerNames#', label: 'Nom(s) et prénom(s) du client', category: 'Client' },
  { code: '#ClientID#', label: 'Identifiant unique du client', category: 'Client' },
  { code: '#NumCNI#', label: 'Numéro de CNI du client', category: 'Client' },
  { code: '#ExpiryDate#', label: "Date d'expiration (CNI...)", category: 'Client' },

  { code: '#AccountID#', label: 'Numéro de compte', category: 'Compte' },
  { code: '#IdPlanDescription#', label: 'Libellé du type de compte / produit', category: 'Compte' },
  { code: '#AvailableBal#', label: 'Solde disponible', category: 'Compte' },

  { code: '#Amount#', label: 'Montant de la transaction', category: 'Transaction' },
  { code: '#Remitter#', label: 'Ordre / bénéficiaire', category: 'Transaction' },
  { code: '#Date#', label: 'Date de la transaction', category: 'Transaction' },

  { code: '#ReceiptID#', label: 'Numéro de bon de caisse / dépôt', category: 'Dépôt à terme' },

  { code: '#LoanApplicationID#', label: 'Numéro du dossier de prêt', category: 'Prêt' },
  { code: '#NumDos#', label: 'Numéro du dossier de prêt', category: 'Prêt' },
  { code: '#InstallmentDate#', label: "Date d'échéance", category: 'Prêt' },
  { code: '#InstallmentAmount#', label: "Montant de l'échéance", category: 'Prêt' },
  { code: '#ArrearsAmount#', label: 'Montant en impayé', category: 'Prêt' },
  { code: '#PenaltyAmount#', label: 'Montant de la pénalité', category: 'Prêt' },
  { code: '#datEch#', label: "Date d'échéance impayée", category: 'Prêt' },

  { code: '#PubliciteID#', label: 'Message publicitaire / signature', category: 'Général' },
];

export default SmsPlaceholders;